import colors from '@v2/styles/colors';
import { css } from '@emotion/css'

export default css({
    position: 'absolute',
    top: 25,
    right: 18,

    '.tag': {
        fontSize: 13,
        lineHeight: '13px',
        letterSpacing: '0.01em',
        color: colors.RED,
        padding: '5px 6px',
        background: colors.WHITE,
        borderRadius: 3,
    },

    '& > *': {
        display: 'inline-block'
    },

    '.tooltip': {
        marginLeft: 2,
        position: 'relative',
        top: 6,
    },
});
